export default __webpack_public_path__ + "static/media/cloth-pointer.8dcd69ed.png";